"use client";

import React from "react";

import CruiseComponent from "@/app/components/cruise";
import CruiseProvider from "@/app/components/cruise/provider/cruise.provider";
import { CruisePageType } from "@/app/components/cruise/types/cruise.type";

function CruisePage({ magnoliaData }: CruisePageType) {
  return (
    <CruiseProvider initialValue={magnoliaData}>
      <CruiseComponent />
    </CruiseProvider>
  );
}

export default CruisePage;
